// @todo Fonction de changement de ville
// @todo search

(function addXhrProgressEvent($) {
    var originalXhr = $.ajaxSettings.xhr;
    $.ajaxSetup({
        progress: function() { },
        xhr: function() {
            var req = originalXhr(), that = this;
            if (req) {
                if (typeof req.addEventListener == "function") {
                    req.addEventListener("progress", function(evt) {
                        that.progress(evt);
                    },false);
                }
            }
            return req;
        }
    });
})(jQuery);

YP.HomeSearchManager = function() {
    return {
        init: function() {
            $('body.home .filters-list a').on('click', { klass: this}, function(e){
                $(this).toggleClass('active');
                e.data.klass.doSearch(e);
            });
            $('body.home .filters-pricetag').on('change', { klass: this }, this.doSearch);
            $('body.home .filters-date').on('change', { klass: this }, this.doSearch);

            // changement de ville
            $('body.home .search.city-on').hover(function(){
                $('.change-country').show();
            }, function(){
                $('.change-country').hide();
            });

            $('.search-input').on('click', { klass :this}, function(e) {
                $('.navbar-search').attr('style', 'opacity: 1');
                $('body.home .search.city-off').hide();
                $('body.home .search.city-on').show();
            });

            $('body.home a.change-country').on('click', { klass :this}, function(e) {
                $('.navbar-search').attr('style', 'opacity: 0.4');
                $('body.home .search.city-off').show();
                $('body.home .search.city-on').hide();
                // $('body.home .top-block').css({
                //     'padding-bottom': '100px'
                // });
                $('.change-country-field').focus().select();
            });

            $('.change-country-form').on('submit', { klass: this}, function(e){
                var city = $('.change-country-field').val().replace(/<(?:.|\n)*?>/gm, '');
                $('body.home .filters').data('city', city);
                $('.navbar-search').attr('style', 'opacity: 1');

                $('body.home .search.city-off').hide();
                $('body.home .search.city-on').show();

                $('body.home .user-country').html(city);

                // $('body.home .top-block').css({
                //     'padding-bottom': '0'
                // });

                $("html, body").animate({ scrollTop: $('body.home .filters-list').offset().top - 20}, 1000);

                saveCityUrl = $('body.home .filters').data('savecityurl');
                $.ajax({
                    type: 'POST',
                    url: saveCityUrl,
                    data: {
                        city: city
                    },
                    success:function(data){
                        e.data.klass.doSearch(e);
                        // changer la cover
                    }
                });
                // @todo sauvegarder la ville (cookie + user base)
                e.preventDefault();
            });
        },

        doSearch: function(e) {

            // récupérer categories

            $('.sub-title .fa-spinner').show();
            var categories = [];
            $('body.home .filters-list a.active').each(function(i, e){
                categories.push($(e).data('catid'));
            });

            // récupérer filres
            var price = null;
            price = $('body.home .filters-pricetag').val();

            var date = null;
            date = $('body.home .filters-date').val();

            // récupérer ville
            city = $('body.home .filters').data('city');

            params = {
                city: city,
                price: price,
                interval: date,
                categories: categories
            }

            var url = $('body.home .filters').data('url');

            realUrl = url+'?'+$.param(params).replace('%01', '');
            realUrl.replace('%01', '');


            if($.browser.msie  && parseInt($.browser.version, 10) === 8) { } else {
                history.pushState({}, "Recherche", realUrl);
            }

            $.ajax({
                type: 'GET',
                url: url,
                data: params,
                success:function(data){
                    $('.sub-title .fa-spinner').hide();
                    $('body.home .events').html(data);
                }
            });
            // console.log(e);
            e.preventDefault();
        }
    }
}


window.addEventListener("load", function(){
    YP.HomeSearchManager().init();
});